import {
    CONVERTER_CATEGORY_QUERIES,
    ConverterCategory,
    ConverterCategoryOptions,
    ConverterCategoryQuery,
} from 'models';

export type { PrimaryPortBase } from 'models';
export {
    DEFAULT_PRIMARY_PORT_BASE,
    getConverterCategoriesPorts,
    getConverterCategory,
    getConverterCategoryDefaultQuery,
    getPortsWithoutCategory,
    getPrimaryPortBase,
    getRestPorts,
    isDefaultPort,
    SOLID_STATE_TRANSFORMER_MIN_AC_VOLTAGE,
} from 'models';

export type ConverterCategoriesPreset = ConverterCategoryQuery & {
    label: string;
    description: string;
};

const PRESENTATION: Record<ConverterCategory, { description: string }> = {
    [ConverterCategory.SOLAR_INVERTER]: {
        description: 'Converts DC power from solar panels into AC for the grid or AC loads',
    },
    [ConverterCategory.HYBRID_INVERTER]: {
        description: 'Solar inverter with a bidirectional DC battery port for charging and discharging storage',
    },
    [ConverterCategory.MPPT_TRACKER]: {
        description: "Maximizes solar harvest by tracking the panels' maximum power point (DC-DC)",
    },
    [ConverterCategory.RECTIFIER]: {
        description: 'Converts incoming AC power into DC for charging or DC loads',
    },
    [ConverterCategory.PCS]: {
        description: 'Bidirectional AC-DC converter for charging and discharging energy storage',
    },
    [ConverterCategory.DC_DC_CONVERTER]: {
        description: 'Converts DC power between voltage levels, such as DC-DC charging modules',
    },
    [ConverterCategory.SOLID_STATE_TRANSFORMER]: {
        description: 'Medium-voltage AC-DC conversion with an AC input rated above 1 kV',
    },
};

export const CONVERTER_CATEGORIES: ConverterCategoriesPreset[] = ConverterCategoryOptions.map((option) => ({
    ...CONVERTER_CATEGORY_QUERIES.find((query) => query.value === option.value)!,
    ...PRESENTATION[option.value],
    label: option.label,
}));
